// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";
import Helmet            from "preact-helmet";
import { ScrollTop }     from "shared-components";
import { HttpNotFound }  from "redux-express";
import { stutter,
         slideUp }       from "../../helpers/animations";

import Button from "../../components/Button";

export default class NotFound extends PureComponent {
  render(props: Props, state: any, { t }: Context) {
    return (
      <div class={styles.block}>
        <div>
          <h1 class={classNames(styles.heading, slideUp)}>
            <span
                style={{ display: "block" }}
                class={slideUp}>

              {t("404.HEADING")}
            </span>
          </h1>

          <p
              dangerouslySetInnerHTML={{ __html: t("404.SUBHEADING") }}
              style={stutter(1)}
              class={classNames(
                styles.text,
                slideUp,
                "text_row__large"
              )}
          />

          <Button
              to="/"
              modifiers="primary"
              style={stutter(2)}
              class={slideUp}>

            {t("404.TO_START")}
          </Button>
        </div>

        <ScrollTop />

        <Helmet title={t("404.TITLE")} />
        <HttpNotFound />
      </div>
    );
  }
}
